// import modular routes
import infoRoutes from "../Info/layouts/InfoRoute";
import memberRoutes from "../Member/layouts/MemberRoute";

export default [...infoRoutes, ...memberRoutes];
// export default [ ...memberRoutes];

